import { Component } from '@angular/core';
import { LoginComponent } from '../login.component';

@Component({
  selector: 'app-mobile-login',
  templateUrl: './login.mobile.component.html',
  styleUrls: ['./login.mobile.component.scss']
})
export class LoginMobileComponent extends LoginComponent {
}  
